/**
 * Format a group type from the database representation to a more readable form
 * 
 * @param {string} type - The group type from the database (e.g., "CLUB", "CITYTEAM", "PROJECTTEAM")
 * @returns {string} - The formatted, human-readable type
 */
export const formatGroupType = (type) => {
    if (!type) return 'Unknown Type';
    
    // Convert to lowercase first (will capitalize first letters properly later)
    const lowercaseType = type.toLowerCase();
    
    // Handle different types with special formatting
    switch (lowercaseType) {
        case 'club':
            return 'Club';
            
        case 'cityteam':
            return 'City Team';
            
        case 'projectteam':
            return 'Project Team';
            
        case 'citycouncil':
            return 'City Council';
            
        case 'localcouncil':
            return 'Local Council';
            
        default:
            // For any other type, add spaces between camel case words and capitalize first letter
            // Convert camelCase or all caps to words with spaces
            const withSpaces = lowercaseType
                .replace(/([A-Z])/g, ' $1') // Add space before capital letters
                .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
                
            return withSpaces.trim(); // Remove any leading/trailing spaces
    }
}; 